<ng-container *ngIf="!loading">
  <app-card
    [className]="'card--summary'"
    [type]="CardType.CONTACT"
    [project]="project"
  >
  </app-card>

  <div class="conversations" *ngIf="tickets.length">
    <app-card
      [className]="'card--conversation ion-activatable'"
      role="link"
      tabindex="0"
      (click)="openTicket(ticket)"
      *ngFor="let ticket of tickets; let index = index"
    >
      <div class="card--conversation__meta">
        <span>
          #{{ index + 1 }}:
          {{ ticket.subject }}
        </span>
        <span
          *ngIf="!DateHelper.isToday(ticket.lastInteractionDate)"
          class="date"
          >{{ ticket.lastInteractionDate | date : 'd-M-Y' }}</span
        >
        <span
          *ngIf="DateHelper.isToday(ticket.lastInteractionDate)"
          class="date"
          >{{ ticket.lastInteractionDate | date : 'shortTime' }}</span
        >
      </div>
      <div class="card--conversation__text">
        <div
          [innerHTML]="
            (ticket.firstMessage.attachment ? '📷 ' : '') +
            (ticket.firstMessage?.content?.replaceAll('href=', '') ?? '')
          "
        ></div>
        <span
          aria-hidden="true"
          [inlineSVG]="'/assets/icons/card/chevron-right.svg'"
        ></span>
        <ion-ripple-effect></ion-ripple-effect>
      </div>
    </app-card>
  </div>

  <app-card [className]="'card--summary'" *ngIf="chatEnabled">
    <div class="card--form">
      <div class="card__head">
        <div class="card--summary__title">
          <h3>{{ 'project.home.contact.title' | translate }}</h3>
        </div>
      </div>
      <form [formGroup]="contactForm" (submit)="send()">
        <app-form-group [form]="contactForm" errorPath="name">
          <label class="label required" for="name">{{
            'contact.name' | translate
          }}</label>
          <input
            type="text"
            class="input-control"
            formControlName="name"
            id="name"
            placeholder="{{ 'contact.name.placeholder' | translate }}"
          />
        </app-form-group>

        <app-form-group [form]="contactForm" errorPath="subject">
          <label class="label required" for="subject">{{
            'contact.subject' | translate
          }}</label>
          <input
            type="text"
            class="input-control"
            formControlName="subject"
            id="subject"
            placeholder="{{ 'contact.subject.placeholder' | translate }}"
          />
        </app-form-group>

        <app-form-group [form]="contactForm" errorPath="message">
          <label class="label required" for="message">{{
            'contact.message' | translate
          }}</label>
          <textarea
            class="input-control"
            rows="7"
            formControlName="message"
            id="message"
            placeholder="{{ 'contact.message.placeholder' | translate }}"
          ></textarea>
        </app-form-group>

        <app-form-group class="file">
          <label class="label">{{ 'contact.attachment' | translate }}</label>
          <app-file-input
            (fileChanged)="setUploadedFile($event)"
          ></app-file-input>
        </app-form-group>

        <button
          type="button"
          (click)="send()"
          [attr.disabled]="loading ? true : null"
        >
          {{ 'contact.submit' | translate }}
          <app-loader [loading]="loading"></app-loader>
        </button>
      </form>
    </div>
  </app-card>
</ng-container>
<app-loader [loading]="loading" [withPadding]="true"></app-loader>
